"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.InternalSettingsContext = void 0;
const react_1 = require("react");
exports.InternalSettingsContext = react_1.createContext({
    loadInternalSettings: () => Promise.resolve(),
    saveInternalSettings: () => Promise.resolve(),
    settingGroups: [],
    loading: false,
});
//# sourceMappingURL=internal-settings-context.js.map